import { Ziggy } from './ziggy';

const { host, hostname: baseDomain, port: basePort, protocol } = window.location;

const baseUrl = `${protocol}//${host}/`;

const baseProtocol = protocol.replace(/:$/, '');

const overrides = {
    baseUrl,
    baseProtocol,
    baseDomain,
    basePort,
};

Object.assign(Ziggy, overrides);

export { Ziggy };
